module.exports = __webpack_public_path__ + "static/media/Resume.09510f1d.pdf";